// extracted by mini-css-extract-plugin
export default {"loader":"PageLoader_loader__9qpIu","spinner":"PageLoader_spinner__0qpsK"};